/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

var getStopStyle = function getStopStyle(position, isVertical) {
  return isVertical ? {
    top: "calc(".concat(100 - position, "% - 1px)")
  } : {
    left: "".concat(position, "%")
  };
};
var formatSlderValue = function formatSlderValue(val, type) {
  if (type === "first") {
    if (val instanceof Array) {
      return val[0];
    }

    return val;
  }

  if (val instanceof Array) {
    return val[1];
  }

  return 0;
};
var formatLabel = function formatLabel(label, val) {
  if (Boolean(label) === false) {
    return String(val);
  }

  if (typeof label === "string") {
    var text = String(val);

    try {
      var rule = /\${value}%/g;
      var enableToReplace = rule.test(label);

      if (enableToReplace) {
        text = label.replace(rule, String(val));
      } else {
        text = label;
        throw new Error();
      }
    } catch (e) {
      console.warn("fail to parse label prop, please pass string such as '${value}%'");
    }

    return text;
  }

  return function () {
    return label;
  };
};

export { formatLabel, formatSlderValue, getStopStyle };
//# sourceMappingURL=common.mjs.map
